import React from 'react'
import './index.sass'

import { useSelector, useDispatch } from 'react-redux';

export default function CommentIndicator() {
    const isCommentIndicatorVisible = useSelector(store => store.commmentIndicator);
    const commentIndicatorName = useSelector(store => store.commentIndicatorName)
    const dispatch = useDispatch();

    const handleHideIndicator = () => {
        dispatch({
            type: 'SET_COMMENT_INDICATOR',
            payload: false
        })
        dispatch({
            type: 'SET_COMMENT_PARENT_ID',
            payload: null
        })
    }
    return (
        <div>
            {isCommentIndicatorVisible &&
                <div id="commentIndicator">
                    <p>Replying to {commentIndicatorName}</p>
                    <img onClick={handleHideIndicator} src={require('../../assets/icons/cross.svg')} />
                </div>
            }
        </div>
    )
}
